import { P } from '@decisiv/ui-components/lib/components/Typography';

import { Container } from './styles';

interface AssetRowProps {
  vin: string;
  ymm?: string;
  /** Shown in red — used on the Invalid VIN tab to explain the rejection. */
  reason?: string;
}

export default function AssetRow({ vin, ymm, reason }: AssetRowProps) {
  return (
    <Container>
      <P size="small" color="alaskanHusky">
        VIN {vin}
      </P>
      {ymm && <P>{ymm}</P>}
      {reason && (
        <P size="small" color="danger">
          {reason}
        </P>
      )}
    </Container>
  );
}
